module.exports = __webpack_public_path__ + "nr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/nr.svg
// module id = 739
// module chunks = 0